var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdTime24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTIme24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#3c3c67"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_24",
    "data-name": 24,
    transform: "translate(9 56.5)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime24);
export default __webpack_public_path__ + "static/media/prodTime24.ce1f6f0fa3fed686f0983e5713150598.svg";
export { ForwardRef as ReactComponent };